import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	helpTooltip: {
		id: 'servicedesk-help-center-select-field.help-me.help-tooltip',
		defaultMessage: 'Help',
		description: 'Aria label for info icon, when hovered over it shows tooltip',
	},
});
